/* eslint-disable no-mixed-operators */
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; // Для редиректа
import { domain } from "./config";

const MobileForm = () => {
    const [translations, setTranslations] = useState({}); // Для хранения переводов
    const [isLoading, setIsLoading] = useState(true); // Состояние загрузки
    const [language, setLanguage] = useState("ru"); // Язык пользователя
    const navigate = useNavigate(); // Для редиректа

    // Функция для получения переводов
    const fetchTranslations = async (lang, initData) => {
        const keys = [
            "history_button",
            "profile_button",
            "buy_description"
        ];
        try {
            const response = await fetch(`${domain}/get-translations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'authorization': initData,
                },
                body: JSON.stringify({ keys, language: lang }),
            });
            const result = await response.json();
            setTranslations(result);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const initTg = async () => {
            if (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp) {
                const tgData = window.Telegram.WebApp;
                const initData = tgData.initData;

                try {
                    const response = await fetch(`${domain}/user`, {
                        method: "GET",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'authorization': initData,
                            'ngrok-skip-browser-warning': "asd"
                        }
                    });

                    if (!response.ok) {
                        tgData.close();
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    if (data?.user?.language_code) {
                        setLanguage(data.user.language_code);
                    }
                    await fetchTranslations(data?.user?.language_code || "ru", initData);
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setIsLoading(false);
                }
            } else {
                setTimeout(initTg, 500);
            }
        };

        initTg();
    }, []);

    const isRu = (language || 'ru').toLowerCase().startsWith('ru');

    const handleContactSupport = () => {
        const url = "https://t.me/taras_cn";
        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        } else {
            window.open(url, "_blank");
        }
    };

    return (
        <div className="form-container">
            {isLoading ? (
                <div className="loading">Loading...</div>
            ) : (
                <>
                    <button className="create-order-btn" onClick={() => navigate('/history')}>
                        {translations.history_button || (isRu ? "Мои заказы" : "My Orders")}
                    </button>
                    <button className="create-order-btn" style={{ "background": "green", "marginLeft": "90px" }} onClick={() => navigate('/profile')}>
                        {translations.profile_button || (isRu ? "Профиль" : "Profile")}
                    </button>

                    <div className="orders-disabled-card">
                        <div className="orders-disabled-icon">🚫</div>
                        <h2 className="orders-disabled-title">
                            {isRu ? "Заказы недоступны" : "Orders are unavailable"}
                        </h2>
                        <p className="orders-disabled-text">
                            {isRu
                                ? "Оформление новых заказов временно недоступно. Пожалуйста, напишите в службу поддержки."
                                : "Placing orders is temporarily unavailable. Please contact support."}
                        </p>
                        <button className="support-action-btn" onClick={handleContactSupport}>
                            💬 {isRu ? "Написать в поддержку" : "Contact Support"}
                        </button>
                    </div>

                    {translations.buy_description && (
                        <div dangerouslySetInnerHTML={{ __html: translations.buy_description }} />
                    )}
                </>
            )}
        </div>
    );
};

export default MobileForm;